/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'react',
	'prop-types',
	'classnames',
	'@ba/ba-ui-carbon-toolkit'
], function (React, PropTypes, classnames, Toolkit) {

	const {
		Button,
		FlexLayout,
		Label,
		EmptyState
	} = Toolkit;

	class DataSourcePanelStatic extends React.Component {
		static propTypes = {
			className: PropTypes.string,
			iconType: PropTypes.string,
			iconId: PropTypes.string,
			title: PropTypes.string.isRequired,
			caption: PropTypes.string,
			button: PropTypes.object
		};

		render() {
			const classNames = {
				dataSourcePanelStatic: true
			};
			if(this.props.className) {
				classNames[this.props.className] = true;
			}
			return (
				<FlexLayout
					className={classnames(classNames)}
					direction='column'
					justifyContent='center'
					alignItems='flex-start'
				>
					{
						this.props.iconType ?
							<EmptyState
								type={this.props.iconType}
								size='large'
							/> :
							null
					}
					<Label
						className='dataSourcePanelStaticTitle'
						label={this.props.title}
					/>
					{
						this.props.caption ?
							<Label
								className='dataSourcePanelStaticCaption'
								label={this.props.caption}
							/> :
							null
					}
					{
						this.props.button ?
							<Button
								className='dataSourcePanelStaticButton'
								{...this.props.button}
							/> :
							null
					}
				</FlexLayout>
			);
		}
	}

	DataSourcePanelStatic.ICON_TYPES = {
		default: 'default',
		error: 'error'
	};

	return DataSourcePanelStatic;
});
